import { Button, Flex, Spin, Typography, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function BleConexionControles({
    cargando,
    onConectar,
    onSimulacion,
    onOmitir,
    simulacionVisible,
    esAdmin,
    disabled = false,
    omitirLabel = "Omitir (sin Bluetooth ni simulación)",
}) {
    return (
        <Flex vertical align="center" gap="middle">
            {cargando ? (
                <Flex vertical align="center" gap="small">
                    <Spin spinning indicator={<LoadingOutlined />} />
                    <Typography.Text>Conectando...</Typography.Text>
                </Flex>
            ) : (
                <>
                    <Button type="primary" onClick={onConectar} disabled={disabled}>
                        Conectar balanza (Bluetooth)
                    </Button>
                    {simulacionVisible ? (
                        <>
                            <Typography.Text type="secondary" style={{ textAlign: "center" }}>
                                Sin hardware: datos sintéticos con el mismo formato que el firmware Jumptech
                                (masa izq., masa der., tiempo).
                                {esAdmin ? " (Perfil administrador)" : ""}
                            </Typography.Text>
                            <Button type="default" onClick={onSimulacion} disabled={disabled}>
                                Generar datos simulados
                            </Button>
                        </>
                    ) : null}
                    {onOmitir ? (
                        <Button type="link" onClick={onOmitir} disabled={disabled}>
                            {omitirLabel}
                        </Button>
                    ) : null}
                </>
            )}
        </Flex>
    );
}

export function avisoBluetoothNoDisponible() {
    message.warning(
        "Este navegador no expone Web Bluetooth (suele requerir HTTPS y Chrome/Edge). Puedes usar «Generar datos simulados»."
    );
}
